import { BulbOutlined } from "@ant-design/icons";
import { aiInsightsCore } from "./core/aiInsights";
import { defineWidget } from "../widgetDefinition";
import { NoSlots } from "../Slots";
import { NoControlPanel, NoDuplication, NoInfo } from "../widgetContract";
import type { AiInsightsComponentSpec } from "../Processing/types";
import { AiInsightsWidget } from "../WidgetComponents/AiInsightsWidget";
import { AiInsightsConfigurator } from "../AddWidgetModal/AiInsightsConfigurator";

export const aiInsightsDefinition = defineWidget<AiInsightsComponentSpec>({
  ...aiInsightsCore,
  type: "ai_insights",
  slots: NoSlots,
  duplicate: NoDuplication,
  controlPanel: NoControlPanel,
  info: NoInfo,
  schema: ["query", "response_length"],
  contractHash: "1v4ap7oe777",

  template: {
    label: "AI Insights",
    description: "Ask a question about this dashboard and render the answer",
    icon: <BulbOutlined />,
  },

  defaultLayout: { w: 3, h: 8, minW: 2, minH: 4 },

  gridComponent: ({ id }) => <AiInsightsWidget id={id} />,

  configurator: {
    modalTitle: "AI Insights Widget",
    wide: false,
    Component: AiInsightsConfigurator as any,
  },
});
